export default {
  state: {
    receberInformativo: true,
    emailHasSend: false
  },

  mutations: {
    SET_RECEBER_INFORMATIVO: (state, value) => {
      state.mail.receberInformativo = value
    },

    SET_MAIL_SEND: (state, value) =>  {
      state.mail.emailHasSend = value
    }
  },

  getters: {
    GET_RECEBER_INFORMATIVO: state => {
      return state.mail.receberInformativo
    },

    GET_MAIL_SEND: state =>  {
      return state.mail.emailHasSend
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeMail.js